import type { ReactNode } from "react";

import { Skeleton } from "@/components/ui/skeleton";
import { abbreviateNumber } from "@/utils/helpers";
import { cn } from "@/utils/lib";

interface ProfileStatProps {
  count: number;
  label: string;
  icon: ReactNode;
  loading?: boolean;
  className?: string;
  variant?: "inline" | "responsiveStacked" | "stacked";
}
export const ProfileStat = ({
  count,
  label,
  icon,
  loading = false,
  className,
  variant = "inline",
}: ProfileStatProps) => {
  if (variant === "stacked" || variant === "responsiveStacked") {
    return (
      <div
        className={cn(
          `
            flex min-w-0 flex-col gap-0.5 text-sm text-muted
            hover:text-foreground
            sm:flex-row sm:items-center sm:gap-2
          `,
          variant === "stacked" && "sm:flex-col sm:items-start sm:gap-0.5",
          className,
        )}
      >
        <span
          className="
            hidden
            md:flex
          "
        >
          {icon}
        </span>
        <span className="font-medium text-foreground">
          {loading ? <Skeleton className="h-4 w-6" /> : abbreviateNumber(count)}
        </span>
        <span className="truncate sm:overflow-visible sm:whitespace-normal">
          {label}
        </span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        `
          flex items-center gap-2 text-sm text-muted
          hover:text-foreground
        `,
        className,
      )}
    >
      <span
        className="
          hidden
          md:flex
        "
      >
        {icon}
      </span>
      <span className="font-medium text-foreground">
        {loading ? <Skeleton className="h-4 w-6" /> : abbreviateNumber(count)}
      </span>{" "}
      {label}
    </div>
  );
};
